import { useState } from "react";
import { getApiService } from "../services/api";
import { navigate } from "../hooks/useRoute";
import { AuthCard } from "../components/AuthCard";
import { useCaptcha } from "../hooks/useCaptcha";
import { isValidPhone, isValidPassword } from "../services/format";

// 忘记密码页
export function ForgotPasswordPage() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { countdown, sending, send } = useCaptcha();

  const submit = async () => {
    setError("");
    if (!isValidPhone(phone)) {
      setError("手机号格式错误");
      return;
    }
    if (!captcha) {
      setError("请输入验证码");
      return;
    }
    if (!isValidPassword(password)) {
      setError("密码需包含大小写字母和数字，8-26位");
      return;
    }
    setBusy(true);
    try {
      const res = await getApiService().resetPassword(phone, captcha, password);
      if (res.code !== 200) {
        setError(res.message ?? "重置失败");
        return;
      }
      navigate("/login");
    } catch {
      setError("网络错误，请稍后重试");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="重置密码">
      <div className="mb-3">
        <label className="label">手机号</label>
        <div className="flex items-center gap-2">
          <span className="input" style={{ width: 64, textAlign: "center", flexShrink: 0 }}>
            +86
          </span>
          <input
            className="input"
            type="tel"
            maxLength={11}
            inputMode="numeric"
            placeholder="请输入手机号"
            value={phone}
            onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
          />
        </div>
      </div>

      <div className="mb-3">
        <label className="label">短信验证码</label>
        <div className="flex gap-2">
          <input
            className="input"
            type="text"
            maxLength={4}
            inputMode="numeric"
            placeholder="4位数字验证码"
            value={captcha}
            onChange={(e) => setCaptcha(e.target.value.replace(/\D/g, ""))}
          />
          <button
            className="btn"
            style={{ flexShrink: 0 }}
            disabled={sending || countdown > 0}
            onClick={async () => {
              const r = await send(phone);
              if (!r.ok) setError(r.message ?? "发送失败");
              else setError("");
            }}
          >
            {countdown > 0 ? `${countdown}s` : "获取验证码"}
          </button>
        </div>
      </div>

      <div className="mb-3">
        <label className="label">新密码</label>
        <input
          className="input"
          type="password"
          placeholder="请输入新密码"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
        />
      </div>

      {error && <div className="down text-13px mb-3">{error}</div>}

      <button className="btn btn-primary w-full py-2.5" disabled={busy} onClick={submit}>
        重置密码
      </button>

      <div className="text-center mt-4 text-13px flat">
        想起密码了？{" "}
        <button className="up" onClick={() => navigate("/login")}>
          去登录
        </button>
      </div>
    </AuthCard>
  );
}
